
export class ModalManagerModel {
  Text: string;
  Title: string;
  Backdrop: any;
  CancelarVisible = false;
  OkText = 'Ok';
  CancelarText = 'Não';

}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/model/modal-manager.model.ts